import React from 'react';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';

import IntlWrapper from './IntlWrapper';
import RootRouter from './routers/RootRouter';

import '@nosferatu500/react-sortable-tree/style.css';

// import '@coreui/coreui/dist/css/coreui.min.css';
import './App.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@coreui/coreui/dist/css/coreui.min.css';

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <IntlWrapper>
                    <RootRouter />
                </IntlWrapper>
            </PersistGate>
        </Provider>
    );
};

export default App;
